import React, { useEffect, useState } from 'react';
import { TextField, CircularProgress, MenuItem } from '@mui/material';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { getBaseCodes } from '../../../../modules/auth';

const BaseCodeSelectbox = ({
  formik,
  name,
  label,
  filterObject,
  variant,
  margin,
  size,
  required,
}) => {
  const [options, setOptions] = useState([]);

  const dispatch = useDispatch();
  const { baseCodes, error, loading } = useSelector(({ auth, loading }) => ({
    baseCodes: auth.baseCodes,
    error: auth.baseCodesError,
    loading: loading['auth/GET_BASECODES'],
  }));

  useEffect(() => {
    if (!baseCodes) {
      dispatch(getBaseCodes());
    } else {
      const filteredList = _.filter(baseCodes, filterObject).map((item) => ({
        ...item,
        step: item.step !== '' && item.step !== null ? parseInt(item.step) : 0,
      }));
      //console.log(filteredList, filterObject);
      const orderedLiist = _.orderBy(filteredList, 'step');

      setOptions(orderedLiist);
    }
  }, [dispatch, baseCodes]);

  // const fetchData = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     const response = await authApi.getBaseCode(filterObject);
  //     if (response.data.list) {
  //       setOptions(response.data.list);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  //   setLoading(false);
  // }, []);

  // useEffect(() => {
  //   let active = true;

  //   if (!loading) {
  //     return undefined;
  //   }

  //   (async () => {
  //     try {
  //       const response = await authApi.getBaseCode(filterObject);

  //       if (active) {
  //         const orderedData =  _.sortBy(response.data.list, ['step'])
  //         setOptions(orderedData);
  //       }
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   })();

  //   return () => {
  //     active = false;
  //   };
  // }, [filterObject, loading]);

  if (loading || !baseCodes) {
    return <CircularProgress color="inherit" size={20} />;
  }

  return (
    <>
      {options.length > 0 ? (
        <TextField
          margin={margin !== null ? margin : ''}
          variant={variant !== null ? variant : 'outlined'}
          required={required}
          fullWidth
          select
          size={size}
          id={name}
          name={name}
          label={label}
          value={formik.values[name] ? formik.values[name] : ''}
          onChange={(event, newValue) => {
            formik.setFieldValue(name, event.target.value);
          }}
          error={formik.touched[name] && Boolean(formik.errors[name])}
          helperText={formik.touched[name] && formik.errors[name]}
        >
          {/* <MenuItem value="">{label}을 선택하세요</MenuItem>
      <Divider variant="middle"/> */}
          {options &&
            options.map((option) => (
              <MenuItem key={option.revVal2} value={option.revVal2}>
                {option.revVal1}
              </MenuItem>
            ))}
        </TextField>
      ) : (
        <>
          <React.Fragment>
            {loading ? <CircularProgress color="inherit" size={20} /> : null}
          </React.Fragment>
        </>
      )}
    </>
  );
};

export default React.memo(BaseCodeSelectbox);
